
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"m16.7 14.404 4.644 4.89v.014a.868.868 0 0 1-.612 1.427H17.95l.048 2.4a.842.842 0 0 1-1.18.786.843.843 0 0 1-.278-.196l-5.446-5.754a.807.807 0 0 1-.217-.434.48.48 0 0 1-.091.139l-5.729 6.062a.846.846 0 0 1-1.458-.59v-2.426H.84a.846.846 0 0 1-.608-1.428l4.635-4.908a2.673 2.673 0 0 0-1.115-1.01l-.547-.265a2.664 2.664 0 0 1-.929-4.058l.382-.473a2.66 2.66 0 0 0 .512-2.252l-.134-.595a2.66 2.66 0 0 1 2.604-3.255h.607a2.652 2.652 0 0 0 2.079-1.002l.382-.473a2.66 2.66 0 0 1 4.161 0l.37.49a2.67 2.67 0 0 0 2.082 1.003h.608a2.66 2.66 0 0 1 2.604 3.254l-.135.595a2.66 2.66 0 0 0 .512 2.252l.382.473a2.665 2.665 0 0 1-.928 4.058l-.547.265c-.461.223-.848.574-1.116 1.01ZM4.445 20.718v2.365l5.39-5.69-.113-.103a.37.37 0 0 0-.095.039l-.547.264a2.66 2.66 0 0 1-3.75-1.805l-.112-.495-4.34 4.557h2.725a.844.844 0 0 1 .842.868Zm3.51-7.214a5.1 5.1 0 1 0 5.67-8.479 5.1 5.1 0 0 0-5.67 8.48Zm9.668 6.429a.83.83 0 0 1 .323-.066l2.747.009-4.34-4.552-.113.468a2.66 2.66 0 0 1-3.749 1.806l-.547-.265a.63.63 0 0 0-.095-.04l-.135.122 5.416 5.668-.022-2.365a.82.82 0 0 1 .243-.599.83.83 0 0 1 .272-.186ZM12.053 8.34l1.08-.807v.017a.435.435 0 1 1 .517.695l-3.715 2.786a.434.434 0 0 1-.582-.057L8.316 9.83a.435.435 0 0 1 .647-.582l.121.109.647.72 2.322-1.736Z","fill":"#1B1B1B"}})])
          )
        }
      }
    